<template>
  <div>
    <edit-info></edit-info>
  </div>
</template>

<script>

import EditInfo from '@/components/EditInfo'

export default {
  name: 'Edit',
  components: {
    EditInfo
  }
}
</script>
